import { z } from 'zod';
/** 2D point in flow-space (React Flow canvas coordinates). */ export const PositionSchema = z.object({
    x: z.number(),
    y: z.number()
});

//# sourceMappingURL=position.schema.js.map